import React, { useState } from 'react';
import { useBooking } from '@/features/Booking/model/store/booking';
import { useBookingModals } from '@/features/Booking/model/store/bookingModals';
import type { PhoneData } from '@/features/Phones/model/types';
import { classNames } from '@/shared/lib/classnames/classnames';
import { Dialog, DialogContent } from '@/shared/ui/dialog';
import { useBookingData } from '../model/hooks/useBookingData';
import { PhoneBookingSection } from './PhoneBookingSection';
import { PhoneDialogHeader } from './PhoneDialogHeader';
import { PhoneDoctorInfo } from './PhoneDoctorInfo';
import { PhoneSlider } from './PhoneSlider';
import type { IScheduleInMedcenter } from '@/entities/medcenter/model/types';
import type { PhoneAndBookingProps } from '../model/types';
export const PhoneAndBooking: React.FC<PhoneAndBookingProps> = ({
  isOpen,
  onClose,
  phones,
  doctorId,
  medcenterId,
  bookingData,
  doctorImage,
  onPhoneCallPreviewGtmEvent,
  onClosePhonesPreviewGtmEvent,
  onBookOnlineGtmEvent
}) => {
  const [viewIndex, setViewIndex] = useState(0);
  const {
    setVisibleBookingModal
  } = useBookingModals();
  const {
    setChangedSlot
  } = useBooking();
  const {
    scheduleData,
    nearestWorkDay,
    formattedSchedule,
    shouldShowLimitVisualItems
  } = useBookingData({
    bookingData,
    doctorId,
    medcenterId
  });
  const handleBookOnlineClick = () => {
    onClose();
    if (doctorId) {
      setVisibleBookingModal(true, doctorId);
    }
    if (typeof onBookOnlineGtmEvent === 'function') {
      onBookOnlineGtmEvent();
    }
  };
  const handleScheduleClick = (item: IScheduleInMedcenter) => {
    onClose();
    if (doctorId) {
      const selectedDay = scheduleData.find(scheduleItem => scheduleItem.day === item.day);
      if (selectedDay?.timeslots?.length) {
        setChangedSlot({
          day: selectedDay,
          slot: selectedDay.timeslots[0],
          id: doctorId
        });
      }
      setVisibleBookingModal(true, doctorId);
    }
    if (typeof onBookOnlineGtmEvent === 'function') {
      onBookOnlineGtmEvent();
    }
  };
  const handlePhoneCallPreview = (phoneNumber: PhoneData) => {
    if (typeof onPhoneCallPreviewGtmEvent === 'function') {
      onPhoneCallPreviewGtmEvent(phoneNumber);
    }
  };
  const handleClosePhonesPreview = () => {
    if (typeof onClosePhonesPreviewGtmEvent === 'function') {
      onClosePhonesPreviewGtmEvent();
    }
    onClose();
  };
  return <Dialog open={isOpen} onOpenChange={open => !open && onClose()} data-sentry-element="Dialog" data-sentry-component="PhoneAndBooking" data-sentry-source-file="index.tsx">
      <DialogContent removeScrollLock className="p-0 md:w-full md:max-w-sm" variant="modal" overlayClick={handleClosePhonesPreview} data-sentry-element="DialogContent" data-sentry-source-file="index.tsx">
        <div className={classNames('bg-gradient-to-t from-[#0077C6] to-[#83A2FF] p-4', {
        'pb-8': phones.length > 1
      })}>
          <PhoneDialogHeader onClose={handleClosePhonesPreview} data-sentry-element="PhoneDialogHeader" data-sentry-source-file="index.tsx" />
          <PhoneDoctorInfo doctorImage={doctorImage} data-sentry-element="PhoneDoctorInfo" data-sentry-source-file="index.tsx" />
          <PhoneSlider phones={phones} viewIndex={viewIndex} onViewIndexChange={setViewIndex} onPhoneCallPreview={handlePhoneCallPreview} data-sentry-element="PhoneSlider" data-sentry-source-file="index.tsx" />
        </div>

        <PhoneBookingSection nearestWorkDay={nearestWorkDay} formattedSchedule={formattedSchedule} shouldShowLimitVisualItems={shouldShowLimitVisualItems} onBookOnlineClick={handleBookOnlineClick} onScheduleClick={handleScheduleClick} data-sentry-element="PhoneBookingSection" data-sentry-source-file="index.tsx" />
      </DialogContent>
    </Dialog>;
};